<!-- 标签管理列表 -->
<template>
    <div id="goodSearch" class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.add" @click="showLevelInfoes()">{{ permission.add }}</el-button>
                <el-button size="small" icon="el-icon-setting" class="search-btn" type="primary" v-if="permission.quickSort" @click="quickSort">{{
                    permission.quickSort
                }}</el-button>
                <div class="explain">（ * 温馨提醒：请适度建立价格段，价格段越多，相对应需要设置商品的价格工作量越大 ）</div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column min-width="150px" prop="LevelName" label="价格段位名称" show-overflow-tooltip> </el-table-column>
                <el-table-column width="150px" prop="PriceType" label="价格类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.PriceType == 1 ? '成本价' : scope.row.PriceType == 2 ? '批发价' : scope.row.PriceType == 3 ? '销售价' : '-' }}
                    </template>
                </el-table-column>
                <el-table-column width="150px" prop="PricePoint" label="点数" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.PriceType == 0 ? '-' : scope.row.PricePoint }}
                    </template>
                </el-table-column>
                <el-table-column min-width="100px" prop="LevelNum" label="级别数序" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="160px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120px" prop="Updator" label="更新人" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="160" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button type="text" size="mini" @click="showLevelInfoes(scope.row.LevelId)" v-if="permission.edit">{{ permission.edit }}</el-button>
                            <el-button type="text" size="mini" style="color: red" @click="delLevel(scope.row.LevelId)" v-if="permission.del">{{ permission.del }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogLevelVisible" width="600px">
            <div class="dialog-content" v-if="dialogLevelVisible">
                <UnionPriceLevelEdit ref="priceLevelEdit" :levelId="levelId" :count="tableDataLength" @closeDialog="closeLevelDialog"></UnionPriceLevelEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="快速排序" :visible.sync="dialogQuickSortVisible" width="500px">
            <div class="dialog-content" v-if="dialogQuickSortVisible">
                <UnionPriceLevelSort ref="priceLevelSort" :levelDatas="tableData" @closeDialog="closeQuickSortDialog"></UnionPriceLevelSort>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import UnionPriceLevelEdit from '@/components/entpUnion/goodsManage/unionPriceLevelEdit';
import UnionPriceLevelSort from '@/components/entpUnion/goodsManage/unionPriceLevelSort';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'priceLevel',
    components: {
        breadcrumb,
        elTableColumn,
        UnionPriceLevelEdit,
        UnionPriceLevelSort
    },
    data() {
        return {
            loading: false,
            unionId: this.$util.getLocalStorage('currentUnion'),
            levelId: '',
            title: '',
            dialogLevelVisible: false,
            dialogQuickSortVisible: false,
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getUnionPermission('PriceLevelsManage');
    },
    methods: {
        // 获取数据
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetUnionPriceLevelList',
                    data: { UnionId: this.unionId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        showLevelInfoes(levelId) {
            if (levelId) {
                this.levelId = levelId;
                this.title = '编辑商品价格段位';
            } else {
                this.levelId = '';
                this.title = '添加商品价格段位';
            }
            this.dialogLevelVisible = true;
        },
        closeLevelDialog(isEdit) {
            if (isEdit) {
                this.getTableData();
            }
            this.dialogLevelVisible = false;
        },
        delLevel(levelId) {
            let that = this;
            if (levelId) {
                that.$confirm('您确认要删除该价格段位吗？如果删除价格段会同步删除商品对应该价格段的价格设置', '提示', {
                    confirmButtonText: '确定继续删除',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnionGoods/DelUnionPriceLevel',
                                data: {
                                    UnionId: that.unionId,
                                    LevelId: levelId
                                },
                                hideLoading: true
                            })
                            .then(() => {
                                that.$util.successMsg('成功删除价格段位');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            } else that.$util.warningMsg('请选择要删除的价格段位');
        },
        quickSort() {
            this.dialogQuickSortVisible = true;
        },
        closeQuickSortDialog(isEdit) {
            if (isEdit) {
                this.getTableData();
            }
            this.dialogQuickSortVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.explain {
    flex-shrink: 0;
    margin: 0 10px 10px;
    height: 32px;
    line-height: 32px;
    color: #ef7a82;
}
</style>
